module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Berry Fleming\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Berry Fleming was an American novelist. He is best known for his 1943 novel "), _c('I', [_vm._v("Colonel Effingham’s Raid")]), _vm._v(". He was born in 1899 and died in 1989. Permanent Press reissued several novels in the 80s. He received a resurgence in popularity with the publication of his last novel, "), _c('I', [_vm._v("Captain Bennett’s Folly")]), _vm._v(", in 1989 just months before his death. The work was favorably reviewed in "), _c('I', [_vm._v("The New York Times")]), _vm._v(", among other publications, and since then many of his earlier neglected novels have been republished with more successful sales than during his lifetime.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16GPJys/tc-custom/9781453293959.jpg?1689214976115",
      "alt": "This image is the cover for the book Captain Bennett's Folly"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Captain Bennett's Folly\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Captain Bennett’s Folly")]), _vm._v(" is a direct descendant of Fleming’s earlier comic novels, "), _c('i', [_vm._v("Colonel Effingham's Raid")]), _vm._v(" and "), _c('i', [_vm._v("Lucinderella")]), _vm._v(". Like them, there is a narrator—in this case Walker Williams—who reports an adventure replete with rogues and innocents, while making an artful, funny and wistful case about the immorality of our times. Walker spins out a tale of how he and his hedonistic family journey to the Florida Keys during the hurricane season in order to prevent rich Uncle Nolan Bennett—“pushing eighty but not pushing very hard”—from marrying his young housekeeper and supplanting them as his legitimate heirs. The scheming relatives, however, have a tough adversary in the eccentric Uncle Nolan, and his struggles to escape from their manipulation are at the core of Fleming’s yarn."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0